import React from 'react';

function Footer() {
    return (
        <footer className="App-footer">
            <p>&copy; 2025 OpsMaster Bartłomiej Więckowski. All rights reserved.</p>
        </footer>
    );
}

export default Footer;
